export const GLOBAL_REQ_CANCEL = 'GLOBAL_REQ_CANCEL';
export const LOG_EVENT = 'LOG_EVENT';
export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
export const SHOW_MODAL = 'SHOW_MODAL';
export const CLEAR_MODAL = 'CLEAR_MODAL';
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';

//ActivityAudit actions
export const GET_SHOW_FS_OBJECT_ACTIVITY_AUDIT =
  'GET_SHOW_FS_OBJECT_ACTIVITY_AUDIT';

//Tag actions
export const GET_TAGS = 'GET_TAGS';

//User actions
export const GET_USER_FROM_SESSION = 'GET_USER_FROM_SESSION';
export const GET_USER_TEAMS = 'GET_USER_TEAMS';
export const GET_USER_EVENTS = 'GET_USER_EVENTS';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_LATEST_ROLES = 'UPDATE_USER_LATEST_ROLES';
export const UPDATE_USER_PASSWORD = 'UPDATE_USER_PASSWORD';
export const LOGOUT_USER = 'LOGOUT_USER';
export const GET_USER_SELF_SERVICE_FEATURE_TOGGLES =
  'GET_USER_SELF_SERVICE_FEATURE_TOGGLES';
export const CREATE_PASS_RESET_TOKEN = 'CREATE_PASS_RESET_TOKEN';

//Event actions
export const GET_EVENT = 'GET_EVENT';
export const RESTORE_EVENT = 'RESTORE_EVENT';
export const GET_EVENT_SHOWS = 'GET_EVENT_SHOWS';
export const GET_EVENT_ELIGIBLE_MEMBERS = 'GET_EVENT_ELIGIBLE_MEMBERS';
export const START_EDITING_EVENT = 'START_EDITING_EVENT';
export const START_CREATING_EVENT = 'START_CREATING_EVENT';
export const START_DUPLICATING_EVENT = 'START_DUPLICATING_EVENT';
export const CANCEL_EDITING_EVENT = 'CANCEL_EDITING_EVENT';
export const CANCEL_DUPLICATING_EVENT = 'CANCEL_DUPLICATING_EVENT';
export const CANCEL_CREATING_EVENT = 'CANCEL_CREATING_EVENT';
export const UPDATE_EVENT = 'UPDATE_EVENT';
export const CREATE_EVENT = 'CREATE_EVENT';
export const ARCHIVE_EVENT = 'ARCHIVE_EVENT';
export const DELETE_EVENT = 'DELETE_EVENT';
export const DUPLICATE_EVENT = 'DUPLICATE_EVENT';
export const UPDATE_EVENT_PHOTO = 'UPDATE_EVENT_PHOTO';
export const UPDATE_EVENT_LABELS = 'UPDATE_EVENT_LABELS';
export const GET_EVENT_CREW = 'GET_EVENT_CREW';
export const UPDATE_EVENT_ROLE = 'UPDATE_EVENT_ROLE';
export const DELETE_EVENT_ROLE = 'DELETE_EVENT_ROLE';
export const RESEND_EVENT_INVITE = 'RESEND_EVENT_INVITE';
export const CREATE_EVENT_ROLE = 'CREATE_EVENT_ROLE';
export const CREATE_AND_INVITE_USERS = 'CREATE_AND_INVITE_USERS';
export const SEARCH_USER_EVENTS = 'SEARCH_USER_EVENTS';
export const CLEAR_SEARCH_USER_EVENTS = 'CLEAR_SEARCH_USER_EVENTS';
export const CREATE_GLOBAL_ELEMENT_LABEL = 'CREATE_GLOBAL_ELEMENT_LABEL';
export const UPDATE_EVENT_LABEL = 'UPDATE_EVENT_LABEL';
export const RESET_EVENT_CHAT = 'RESET_EVENT_CHAT';
export const UPDATE_AVAILABLE_TOOLS = 'UPDATE_AVAILABLE_TOOLS';
export const CREATE_TRIAL_EVENT = 'CREATE_TRIAL_EVENT';
export const INVITE_CREW_BY_EMAIL = 'INVITE_CREW_BY_EMAIL';

//Event FS actions
export const GET_EVENT_FS_OBJECT = 'GET_EVENT_FS_OBJECT';
export const GET_EVENT_FS_OBJECT_CHILDREN = 'GET_EVENT_FS_OBJECT_CHILDREN';
export const SET_EVENT_FS_OBJECT_SORTING = 'SET_EVENT_FS_OBJECT_SORTING';
export const SET_ARCHIVED_EVENT_FS_OBJECT_SORTING =
  'SET_ARCHIVED_EVENT_FS_OBJECT_SORTING';
export const DOWNLOAD_EVENT_FS_DOC = 'DOWNLOAD_EVENT_FS_DOC';
export const MOVE_EVENT_FS_OBJECT = 'MOVE_EVENT_FS_OBJECT';
export const MULTI_SELECT_FS_OBJECT = 'MULTI_SELECT_FS_OBJECT';
export const CREATE_FS_FOLDER = 'CREATE_FS_FOLDER';
export const CREATE_FS_DOC = 'CREATE_FS_DOC';
export const CREATE_FS_DOCS = 'CREATE_FS_DOCS';
export const SEARCH_FS_OBJECTS = 'SEARCH_FS_OBJECTS';
export const SEARCH_ARCHIVED_FS_OBJECTS = 'SEARCH_ARCHIVED_FS_OBJECTS';
export const CLEAR_SEARCH_ARCHIVED_FS_OBJECTS =
  'CLEAR_SEARCH_ARCHIVED_FS_OBJECTS';
export const CLEAR_SEARCH_FS_OBJECTS = 'CLEAR_SEARCH_FS_OBJECTS';
export const SET_UPLOAD_STATUS_VISIBILITY = 'SET_UPLOAD_STATUS_VISIBILITY';
export const ARCHIVE_EVENT_FS_OBJECT = 'ARCHIVE_EVENT_FS_OBJECT';
export const GET_ARCHIVED_EVENT_FS_OBJECTS = 'GET_ARCHIVED_EVENT_FS_OBJECTS';
export const DELETE_EVENT_FS_OBJECT = 'DELETE_EVENT_FS_OBJECT';
export const RESTORE_EVENT_FS_OBJECT = 'RESTORE_EVENT_FS_OBJECT';
export const UPDATE_FOLDER = 'UPDATE_FOLDER';
export const UPDATE_EVENT_DOC = 'UPDATE_EVENT_DOC';

//Team actions
export const GET_TEAM = 'GET_TEAM';
export const GET_TEAM_MEMBERS = 'GET_TEAM_MEMBERS';
export const GET_TEAM_EVENTS = 'GET_TEAM_EVENTS';
export const CREATE_TEAM_LABEL = 'CREATE_TEAM_LABEL';
export const SEARCH_TEAM_EVENTS = 'SEARCH_TEAM_EVENTS';
export const CLEAR_SEARCH_TEAM_EVENTS = 'CLEAR_SEARCH_TEAM_EVENTS';
export const UPDATE_TEAM_PRODUCT_PERMISSION = 'UPDATE_TEAM_PRODUCT_PERMISSION';
export const UPDATE_TEAM = 'UPDATE_TEAM';
export const UPDATE_TEAM_PHOTO = 'UPDATE_TEAM_PHOTO';
export const GET_TEAM_ELIGIBLE_MEMBERS = 'GET_TEAM_ELIGIBLE_MEMBERS';
export const CREATE_AND_INVITE_ADMINS = 'CREATE_AND_INVITE_ADMINS';
export const CREATE_TEAM_ADMIN = 'CREATE_TEAM_ADMIN';
export const RESEND_TEAM_INVITE = 'RESEND_TEAM_INVITE';
export const DELETE_TEAM_ADMIN = 'DELETE_TEAM_ADMIN';
export const GET_TEAM_ARCHIVE_EVENTS = 'GET_TEAM_ARCHIVE_EVENTS';
export const GET_TEAM_PAST_EVENTS = 'GET_TEAM_PAST_EVENTS';
export const CREATE_TEAM = 'CREATE_TEAM';

export const GET_ACTIVE_USERS = 'GET_ACTIVE_USERS';
export const GET_ASSIGNED_EVENT_TOOLS = 'GET_ASSIGNED_EVENT_TOOLS';

//Broadcast actions
export const CREATE_BROADCAST = 'CREATE_BROADCAST';
export const UPDATE_BROADCAST = 'UPDATE_BROADCAST';
export const DUPLICATE_BROADCAST = 'DUPLICATE_BROADCAST';

export const RESEND_VERIFY_EMAIL = 'RESEND_VERIFY_EMAIL';
